import * as React from 'react'
import styled from 'styled-components'
import Svg from './Svg'

function BaseComponent(props: any) {
  return (
    <Svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 .5a.5.5 0 01.5-.5h12a.5.5 0 010 1h-12A.5.5 0 011 .5zM7 2a1 1 0 00-1 1v3a1 1 0 001 1h1a1 1 0 001-1V3a1 1 0 00-1-1H7zm0 6a1 1 0 00-1 1v3a1 1 0 001 1h1a1 1 0 001-1V9a1 1 0 00-1-1H7zm-5.5 6a.5.5 0 000 1h12a.5.5 0 000-1h-12z"
        fill="currentColor"
      />
    </Svg>
  )
}

const SvgSpaceEvenlyVertically = styled(BaseComponent)`
  outline: none;
`
export default SvgSpaceEvenlyVertically
